import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import MainLayout from './layouts/MainLayout';
import Dashboard from './pages/dashboard/ Dashboard';
import Login from './pages/auth/sudaLogin/Login';
import Municipality from './pages/superAdmin/municipality/Municipality';
import Zone from './pages/superAdmin/zone/zone';
import District from './pages/superAdmin/district/district';
import FinancialYear from './pages/superAdmin/academicYear/AcademicYear';
import School from './pages/ulb/school/school';
import Item from './pages/superAdmin/item/item';
import Member from './pages/ulb/member/member';
import MeasurementList from './pages/ulb/measurementList/measurementList';
import FabricReceive from './pages/ulb/fabricReceive/fabricReceive';
import ReceiveCutpiece from './pages/ulb/receiveCutPiece/receiveCutpiece';
import IssueJobWork from './pages/ulb/issueWork /issueWork';
import AccountStatement from './pages/ulb/account/accountStatement';
import VendorTypeMaster from './pages/ulb/vendorType/vendorType';
import JobWrorkerList from './pages/superAdmin/jobWorkerRate/jobWorkerRateList';
import SizeMaster from './pages/superAdmin/size/sizeList';
import PaymentList from './pages/ulb/payments/payments';
import OverviewList from './pages/ulb/overview/overviewList';
import PaymentTransactionList from './pages/ulb/payments/payementTransactionlist';
import FabricConsumptionMaster from './pages/superAdmin/fabricConsumption/fabricConsumptionList';
import Landing from './pages/landingPage/landingPage';
import SubDiv from './pages/superAdmin/subDiv/subDiv';
import CircleMaster from './pages/superAdmin/circle/circle';
import MunicipalityLogin from './pages/auth/ulbLogin/ulbLogin';
import SchoolCategoryList from './pages/superAdmin/schoolCategory/schoolCategory';
import SchoolType from './pages/superAdmin/schoolType/schoolType';
import SchoolManagementType from './pages/superAdmin/schoolManagementType/schoolManagementType';
import ReportList from './pages/reports/report';
import ClfListReport from './pages/superAdmin/reports/clfListReport';
import AlfListReport from './pages/superAdmin/reports/alfListReport';
import SHGWiseReportList from './pages/ulb/reports/shgWiseReport';
import DeliveryUniform from './pages/ulb/delivery/deliveryUniform';
import MeasurementListNew from './pages/ulb/measurementListNew/measurementListNew';
import DeliveryList from './pages/ulb/delivery/deliveryList';
import IssueFabric from './pages/ulb/issueFabric/issueFabric';
import ReceiveOtherWorks from './pages/ulb/receiveWork/receiveWork';
import UlbWiseMeasurementCountReport from './pages/superAdmin/reports/ulbWiseMeasurementCount';
import TransportationUniform from './pages/ulb/transportation/issueTransportation';
import TransportationList from './pages/ulb/transportation/transportationList';
import GenderWiseItemQuantity from './pages/superAdmin/genderWiseItemQuantity/genderWiseItemQuantity';
import FabricReceiveReport from './pages/superAdmin/reports/fabricReceiveReport';
import OrgWiseCountReport from './pages/ulb/reports/orgWiseCountReport';
import SchoolWiseMeasurementReport from './pages/superAdmin/reports/schoolWiseMeasurementReport';
import ActionLogReport from './pages/superAdmin/reports/deleteLogReport';





function App() {


  return (
    <Routes>

      <Route path="/" element={<Navigate to="/landing" />} />

      <Route path="suda/login" element={<Login />} />
        <Route path="ulb/login" element={<MunicipalityLogin />} />
        <Route path='landing' element={<Landing />} />

      {/* MAIN APP AFTER LOGIN */}
      <Route path="/app" element={<MainLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="municipality" element={<Municipality />} />
        <Route path="zone" element={<Zone />} />
        <Route path="district" element={<District />} />
        <Route path="academic-year" element={<FinancialYear />} />
        <Route path="school" element={<School />} />
        {/* <Route path="category" element={<Category />} />
        <Route path="vendor" element={<Vendor />} /> */}
        <Route path="item" element={<Item />} />
        {/* <Route path="clf" element={<CLF />} /> */}
        <Route path=":vendorSlug" element={<VendorTypeMaster />} />
        {/* <Route path="shg" element={<SHG />} /> */}
        <Route path="member" element={<Member />} />
        <Route path="measurement-list" element={<MeasurementList />} />
        {/* <Route path="transaction-list" element={<TransactionList />} /> */}
        <Route path="fabric-receive" element={<FabricReceive />} />
         <Route path="receive-cut-piece" element={<ReceiveCutpiece />} />
         <Route path="issue-job-work" element={<IssueJobWork />} />
         <Route path="account-statement" element={<AccountStatement />} />
         <Route path="job-worker-rate-list" element={<JobWrorkerList />} />
         <Route path="size-list" element={<SizeMaster />} />
         <Route path="transaction-list" element={<PaymentList />} />
         <Route path="overview-list" element={<OverviewList />} />
         <Route path="payment-details/:id" element={<PaymentTransactionList />} />

              <Route path="fabric-consumptions" element={<FabricConsumptionMaster />} />
              <Route path='sub-div' element={<SubDiv />} />
              <Route path='sub-div' element={<SubDiv />} />
              <Route path='circle' element={<CircleMaster />} />
                            <Route path='gender-class-wise-item' element={<GenderWiseItemQuantity />} />


              <Route path='category-list' element={<SchoolCategoryList />} />
              <Route path='school-types' element={<SchoolType />} />
              <Route path='school-management-types' element={<SchoolManagementType />} />
              <Route path='measurement-count-report' element={<ReportList />} />
              {/* <Route path='issue-fabric' element={<IssueFabric />} /> */}

              <Route path='report/clf-list' element={<ClfListReport />} />
              <Route path='report/alf-list' element={<AlfListReport />} />
                            <Route path='report/fabric-receive' element={<FabricReceiveReport />} />

              <Route path='report/member-report' element={<SHGWiseReportList />} />
              <Route path='uniform-delivery' element={<DeliveryUniform />} />
              <Route path='transportation-uniform' element={<TransportationUniform />} />
              <Route path='transportation-list' element={<TransportationList />} />

              <Route path='new-measurement' element={<MeasurementListNew />} />

              <Route path='delivery-list' element={<DeliveryList />} />

              <Route path='issue-fabric' element={<IssueFabric />} />
              <Route path='receive-other-jobs' element={<ReceiveOtherWorks />} />
              <Route path='report/ulb-wise-measurement-count' element={<UlbWiseMeasurementCountReport />} />
              <Route path='report/org-wise-measurement-count' element={<OrgWiseCountReport />} />
                <Route path='report/school-wise-measurement-count' element={<SchoolWiseMeasurementReport />} />
                <Route path='report/action-log-report' element={<ActionLogReport />} />




        {/* <Route path="measurement-summary" element={<MeasurementSummary />} /> */}
        {/* <Route path="order-list" element={<OrderList />} /> */}
        {/* <Route path="cutting-vendor/order-list" element={<WorkOrderList />} />
        <Route path="cutting-vendor/receive-fabric" element={<ReceiveFabric />} />
        <Route path="cutting-vendor/transactions" element={<Transaction />} />
        <Route path="cutting-vendor/inventory" element={<Inventory />} />
        <Route path="cutting-vendor/dispatch" element={<Dispatch />} /> */}







      </Route>

      {/* <Route path='/landing' element={<Landing />} /> */}


    </Routes>
  );
}

export default App;
